module.exports = __webpack_public_path__ + "static/media/join-us-banner-lg.3ef8425b.jpg";